
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"44","viewBox":"0 0 40 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.186 37.8752H28.8146C30.3926 37.8752 31.6717 36.5958 31.6717 35.0181V12.1608C31.6717 10.5829 30.3926 9.30368 28.8146 9.30368H11.186C9.60802 9.30368 8.32882 10.5829 8.32882 12.1608V35.0181C8.32882 36.5958 9.60802 37.8752 11.186 37.8752ZM28.8146 40.7324C31.9706 40.7324 34.5289 38.1738 34.5289 35.0181V12.1608C34.5289 9.0049 31.9706 6.44653 28.8146 6.44653H11.186C8.03005 6.44653 5.47168 9.0049 5.47168 12.1608V35.0181C5.47168 38.1738 8.03005 40.7324 11.186 40.7324H28.8146Z","fill":"#006ABC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.8574 23.5892C12.8574 22.8003 13.497 22.1607 14.286 22.1607H25.7145C26.5035 22.1607 27.1431 22.8003 27.1431 23.5892C27.1431 24.3782 26.5035 25.0178 25.7145 25.0178H14.286C13.497 25.0178 12.8574 24.3782 12.8574 23.5892ZM12.8574 30.4166C12.8574 29.6274 13.497 28.988 14.286 28.988H18.2651C19.0541 28.988 19.6937 29.6274 19.6937 30.4166C19.6937 31.2054 19.0541 31.8451 18.2651 31.8451H14.286C13.497 31.8451 12.8574 31.2054 12.8574 30.4166ZM12.8574 16.7619C12.8574 15.9729 13.497 15.3334 14.286 15.3334H25.6428C26.4318 15.3334 27.0714 15.9729 27.0714 16.7619C27.0714 17.5509 26.4318 18.1905 25.6428 18.1905H14.286C13.497 18.1905 12.8574 17.5509 12.8574 16.7619Z","fill":"#006ABC"}})])
          )
        }
      }
    